import { Injectable } from '@angular/core'
import { AppStore } from '../models/modelsStore'
import { INITIAL_STATE } from '../store-session'

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private KY_STORE = 'sv-store'

  saveStore(store: AppStore) {
    localStorage.setItem(this.KY_STORE, JSON.stringify(store))
  }

  getStore(): AppStore {
    const store = localStorage.getItem(this.KY_STORE)
    return store ? JSON.parse(store) : INITIAL_STATE
  }

  cleanBeforeSession() {
    const store = this.getStore()
    localStorage.clear()
    this.saveStore(store)
  }
}
